const GA4_CODE = "G-8KXWKYXGVF";
export default GA4_CODE;
